const MonthPicker = ({ value, onChange, max, min, style = {} }) => {
  const handleClick = (e) => {
    try { e.target.showPicker(); } catch (_) {}
  };

  const handleFocus = (e) => {
    try { e.target.showPicker(); } catch (_) {}
  };

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', ...style }}>
      {/* Calendar icon */}
      <span style={{
        position:       'absolute',
        left:           9,
        top:            '50%',
        transform:      'translateY(-50%)',
        pointerEvents:  'none',
        display:        'flex',
        alignItems:     'center',
        zIndex:         1,
      }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="#8660F8" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/>
          <line x1="8"  y1="2" x2="8"  y2="6"/>
          <line x1="3"  y1="10" x2="21" y2="10"/>
        </svg>
      </span>

      <style>{`
        .payroll-month-picker::-webkit-calendar-picker-indicator {
          opacity: 0.5;
          cursor: pointer;
          filter: invert(1);
        }
        .payroll-month-picker::-webkit-inner-spin-button {
          display: none;
        }
      `}</style>

      <input
        type="month"
        className="payroll-month-picker"
        value={value || ''}
        max={max}
        min={min}
        onChange={(e) => onChange(e.target.value)}
        onClick={handleClick}
        onFocus={handleFocus}
        style={{
          background:    'var(--pay-surface-2, #1e1a3a)',
          border:        '1px solid rgba(134,96,248,0.3)',
          borderRadius:  8,
          padding:       '5px 10px 5px 28px',
          color:         '#e2dff7',
          fontSize:      12,
          fontFamily:    'Outfit, sans-serif',
          fontWeight:    500,
          cursor:        'pointer',
          outline:       'none',
          height:        30,
          minWidth:      140,
          colorScheme:   'dark',
        }}
      />
    </div>
  );
};

export default MonthPicker;
